import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface ChatMessageProps {
  role: "user" | "assistant";
  content: string;
}

export default function ChatMessage({ role, content }: ChatMessageProps) {
  const isUser = role === "user";

  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4`}>
      <div
        className={`max-w-[85%] sm:max-w-[75%] rounded-2xl px-4 py-3 ${
          isUser
            ? "bg-blue-600 text-white rounded-br-md"
            : "bg-slate-800 text-slate-100 rounded-bl-md"
        }`}
      >
        {isUser ? (
          <p className="text-sm sm:text-base whitespace-pre-wrap leading-relaxed">{content}</p>
        ) : (
          <div className="prose prose-invert prose-sm sm:prose-base max-w-none prose-p:my-1.5 prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0.5 prose-headings:my-2 prose-table:text-sm prose-td:text-slate-200 prose-th:text-slate-100">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}

export function TypingIndicator() {
  return (
    <div className="flex justify-start mb-4">
      <div className="bg-slate-800 rounded-2xl rounded-bl-md px-4 py-3">
        <div className="flex gap-1.5 items-center h-5">
          <span className="typing-dot w-2 h-2 bg-slate-400 rounded-full" />
          <span className="typing-dot w-2 h-2 bg-slate-400 rounded-full" />
          <span className="typing-dot w-2 h-2 bg-slate-400 rounded-full" />
        </div>
      </div>
    </div>
  );
}
